import type { LinkedinAccount } from './linkedin-accounts.types';

/**
 * The account runs at reduced limits after LinkedIn pushed back ("Fuse limit"), for a fixed
 * period. Returns the end date while that phase is active, otherwise null.
 */
export function activeRiskReductionUntil(account: Pick<LinkedinAccount, 'riskReduction'> | undefined, now = new Date()): Date | null {
  const until = account?.riskReduction?.until ? new Date(account.riskReduction.until) : null;
  return until && !Number.isNaN(until.getTime()) && until.getTime() > now.getTime() ? until : null;
}

export function riskReductionPercent(account: Pick<LinkedinAccount, 'riskReduction'> | undefined): number {
  const factor = account?.riskReduction?.factor;
  return typeof factor === 'number' && factor > 0 && factor < 1 ? Math.round(factor * 100) : 100;
}
